import { ca } from '@cian/analytics';

export function trackDragDropEvent() {
  return ca('eventSite', {
    action: 'Drag_and_drop',
    category: 'Compare',
    label: 'flats',
    name: 'oldevent',
  });
}
